export function canDownloadSearchResultItem(document) {
  return (document?.document_handlers ?? [])
    .map((document_handler) => document_handler.visibility_level[0])
    .some((vl) => vl === 'OPEN' || vl === 'OPEN_NO_EDIT');
}
